<template>
  <div>
    <section-definition title="Relatório Quadro Horário" event-update="pesquisar"></section-definition>
    <v-toolbar dark color="primary">
      <v-toolbar-title>Relatório Quadro Horário</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark :disabled="!plano.id" @click="imprimirPlano"
        title="Imprimir relatório do plano">
        <v-icon>print</v-icon>Imprimir
      </v-btn>
    </v-toolbar>
    <v-container fluid>
      <v-form ref="form" class="hidden-sm-and-down">
        <v-layout align-center row fill-height justify-space-between>
          <v-flex xs12 sm6 md2>
            <v-select v-model="filtro.ano" :items="anos" label="Ano" clearable
              @change="aoSelecionarAno"></v-select>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-select v-model="filtro.numero" :items="numeros" label="Número" clearable
              :disabled="!filtro.ano" @change="aoSelecionarNumero"></v-select>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field color="primary" label="Data Início" disabled v-model="plano.dataInicio"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field color="primary" label="Data Fim" disabled v-model="plano.dataFim"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md4>
            <v-text-field color="primary" label="Descrição" disabled v-model="plano.descricao"></v-text-field>
          </v-flex>
        </v-layout>
      </v-form>
      <div class="qh-relatorios-scroll">
        <v-data-table :loading="loading" :headers="headers" :items="linhas" class="elevation-1" hide-actions>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.numeroRegistro }}</td>
            <td>{{ props.item.nome }}</td>
            <td>{{ props.item.funcao }}</td>
            <td class="text-xs-right">{{ props.item.totalPrev }}</td>
            <td class="text-xs-right">{{ props.item.totRecesso }}</td>
            <td class="text-xs-right">{{ props.item.totalExtra }}</td>
            <td class="text-xs-right"><strong>{{ props.item.saldo }}</strong></td>
            <td>
              <v-icon title="Imprimir" medium class="mr-2" @click="imprimirFuncionario(props.item)">
                print
              </v-icon>
            </td>
          </template>
          <template slot="no-data">
            Sem funcionários com previsão neste plano.
          </template>
        </v-data-table>
      </div>
    </v-container>
  </div>
</template>
<script>
import qhRelatorioService from "@/service/qh/QhRelatorioService";
import qhPlanoService from "@/service/qh/QhPlanoService";
import QhPlanoResumo from "@/model/qh/QhPlanoResumo";
export default {
  data() {
    return {
      loading: false,
      linhas: [],
      anos: [],
      numeros: [],
      filtro: { ano: null, numero: null },
      plano: new QhPlanoResumo(),
      headers: [
        { text: "Nr Registro", align: "left", sortable: false, value: "numeroRegistro" },
        { text: "Nome", align: "left", sortable: false, value: "nome" },
        { text: "Função", align: "left", sortable: false, value: "funcao" },
        { text: "Previsto", align: "right", sortable: false, value: "totalPrev" },
        { text: "Recessos", align: "right", sortable: false, value: "totRecesso" },
        { text: "Extras", align: "right", sortable: false, value: "totalExtra" },
        { text: "Saldo", align: "right", sortable: false, value: "saldo" },
        { text: "Ações", value: "name", sortable: false }
      ]
    };
  },
  created() {
    this.carregarAnos();
  },
  methods: {
    async carregarAnos() {
      // RN001.1: anos com planos ATIVOS da instituição.
      this.anos = (await qhPlanoService.listarAnos(true)) || [];
    },
    async aoSelecionarAno() {
      this.filtro.numero = null;
      this.plano = new QhPlanoResumo();
      this.linhas = [];
      if (this.filtro.ano) {
        this.numeros = await qhPlanoService.listarNumeros(this.filtro.ano);
      } else {
        this.numeros = [];
      }
    },
    async aoSelecionarNumero() {
      this.linhas = [];
      this.plano = new QhPlanoResumo();
      if (!this.filtro.numero) {
        return;
      }
      const paginacao = await qhPlanoService.listarTodos(
        { ano: this.filtro.ano, numero: this.filtro.numero }, 1, 1
      );
      if (paginacao && paginacao.dados && paginacao.dados.length > 0) {
        this.plano = new QhPlanoResumo(paginacao.dados[0]);
        this.pesquisar();
      }
    },
    async pesquisar() {
      if (!this.plano.id) {
        this.linhas = [];
        return;
      }
      this.loading = true;
      this.linhas = (await qhRelatorioService.listarLinhasPorPlano(this.plano.id)) || [];
      this.loading = false;
    },
    imprimirPlano() {
      qhRelatorioService.gerarPlanoPdf(this.plano.id);
    },
    imprimirFuncionario(linha) {
      qhRelatorioService.gerarFuncionarioPdf(this.plano.id, linha.id, linha.nome);
    }
  }
};
</script>
<style scoped>
.qh-relatorios-scroll {
  max-height: calc(100vh - 320px);
  overflow-y: auto;
  overflow-x: auto;
}
</style>
